import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  console.log('🛡️ ProtectedRoute - État:', {
    isAuthenticated,
    isLoading,
    shouldRedirect: !isAuthenticated && !isLoading
  });

  if (isLoading) {
    console.log('⏳ ProtectedRoute - Chargement en cours...');
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
          <p className="mt-4 text-gray-500 dark:text-gray-400">
            Chargement...
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('❌ ProtectedRoute - Non authentifié, redirection vers /login');
    return <Navigate to="/login" replace />;
  }

  console.log('✅ ProtectedRoute - Authentifié, affichage du contenu');
  return <>{children}</>;
};